import api from "./api.js";
import regularAppService from "./regularAppService";



export const getOrders = async () => {
  const page = await regularAppService.getPaginated({ collection: "orders" });
  return Array.isArray(page.items) ? page.items : [];
};

export const createOrder = async (orderData) => {
  try {
    // Prefer backend for real-time stock validation and atomic operations
    const storeId = orderData?.userId || orderData?.storeId;
    const payload = { ...orderData };
    return await api.post(`/orders/${storeId}`, payload);
  } catch (err) {
    throw err;
  }
};

export const finalizePendingOrder = async (pendingOrderId, orderData) => {
  return await api.post(`/orders/finalize-pending/${pendingOrderId}`, orderData);
};

export const updateOrder = async ({ orderId, completed }) => {
  const payload = { _id: orderId, completed, updatedAt: new Date().toISOString() };
  const result = await regularAppService.upsert({ collection: "orders", data: payload });
  return result;
};

export const updateOrderData = async ({ orderId, data }) => {
  const payload = { _id: orderId, ...data, updatedAt: new Date().toISOString() };
  const result = await regularAppService.upsert({ collection: "orders", data: payload });
  return result;
};

export const deleteOrder = async (orderId) => {
  const payload = { _id: orderId, deleted: true, updatedAt: new Date().toISOString() };
  const result = await regularAppService.upsert({ collection: "orders", data: payload });
  return result;
};

export const searchOrders = async ({ search = "" }) => {
  const isValid = typeof search === "string" && search.trim().length > 0;
  const pageResult = await regularAppService.getPaginated({
    collection: "orders",
    ...(isValid ? { search } : {}),
  });
  return pageResult.items || [];
};

// Method to force a sync with the server
export const syncOrders = async () => {
  const items = await getOrders();
  return items;
};

export const getDashboardOrders = async (storeId, startDate, endDate, tag) => {
  // No caching is done here as dashboard data is expected to be highly dynamic
  return await api.get("/orders/" + storeId + "/dashboard", {
    params: {
      startDate,
      endDate,
      tag,
    },
  });
};

// Debugging function to reset and check order data
export const debugOrders = async () => {
  return [];
};

export const getOrderById = async (orderId) => {
  const result = await regularAppService.getPaginated({
    collection: "orders",
    page: 1,
    limit: 1,
    filter: { _id: orderId },
  });
  const first = Array.isArray(result.items) ? result.items[0] : null;
  return first || null;
};

// Update order completed status
export const updateOrderCompleted = async (orderId, completed) => {
  return await api.put(`/orders/${orderId}`, { completed });
};

// Add a payment
export const addOrderPayment = async (orderId, payment) => {
  const existing = await getOrderById(orderId);
  const safePayments = Array.isArray(existing?.payments) ? existing.payments : [];
  const payload = {
    _id: orderId,
    payments: [...safePayments, payment],
    updatedAt: new Date().toISOString(),
  };
  const result = await regularAppService.upsert({ collection: "orders", data: payload });
  return result;
};

// Get payments for an order
export const getOrderPayments = async (orderId) => {
  const existing = await getOrderById(orderId);
  const payments = Array.isArray(existing?.payments) ? existing.payments : [];
  return payments;
};

// Delete a payment
export const deleteOrderPayment = async (orderId, paymentId) => {
  const existing = await getOrderById(orderId);
  const safeProducts = Array.isArray(existing?.products) ? existing.products : [];
  const safePayments = Array.isArray(existing?.payments) ? existing.payments : [];
  const payload = {
    _id: orderId,
    products: safeProducts,
    payments: safePayments.filter((p) => p._id !== paymentId),
    updatedAt: new Date().toISOString(),
  };
  const result = await regularAppService.upsert({ collection: "orders", data: payload });
  return {
    ...result,
    products: Array.isArray(result?.products) ? result.products : [],
    payments: Array.isArray(result?.payments) ? result.payments : [],
  };
};
